import { render, staticRenderFns } from "./SetPortalSignatureForm.vue?vue&type=template&id=3ddc6260&"
import script from "./SetPortalSignatureForm.vue?vue&type=script&lang=js&"
export * from "./SetPortalSignatureForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ddc6260')) {
      api.createRecord('3ddc6260', component.options)
    } else {
      api.reload('3ddc6260', component.options)
    }
    module.hot.accept("./SetPortalSignatureForm.vue?vue&type=template&id=3ddc6260&", function () {
      api.rerender('3ddc6260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/clients/client-manage/SetPortalSignatureForm.vue"
export default component.exports